import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/services/monitoring-services/page.tsx");
